module.exports = __webpack_public_path__ + "static/media/22.6753ed89.jpg";